import React, { useState, useEffect } from 'react';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { ContentBox } from '../../Content/ContentBox';
import { ReqModule, RespModuleItem } from '../../../../item/ItemModule';
import { sortBy, uuid } from '../../../../item/ItemTools';
import { setResume2Token, setVal2Token } from '../../../Login/Auth';
import { api_getMoudleList } from '../../../../api/apiModule';

export function MoudleList({ type, setIsLoading }) {
    const [moudleList, setMoudleList] = useState([])


    useEffect(() => {
        toSearch()
    }, [])

    function toSearch() {
        //console.log("toSearch")
        getModuleList()
    }


    async function getModuleList() {
        setIsLoading(true)
        api_getMoudleList({
            success: (obj) => {
                console.log(obj)
                var list = []
                obj.list.map(item => {
                    var mRespModuleItem = new RespModuleItem()
                    mRespModuleItem.fromJson(item)
                    var items = mRespModuleItem.items.sort(sortBy('pageDescription', false, String));
                    console.log(items)
                    // mRespModuleItem.items = items
                    list.push(mRespModuleItem)
                })
                console.log(list)
                setMoudleList(list)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
            }
        })
    }

    function toAdd() {
        window.location.assign("/ModuleAdd");
    }


    var baseTitle = "模組列表"
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox list={moudleList}  sp={toSearch} type={type} />
        </>

    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toAdd()}>
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>

    return (
        <>
            <ContentBox title={baseTitle} title_tools={title_tools} content={baseContent} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ list, type }) {
    const [moduleList, setModuleList] = useState([])
    const [tableList, setTableList] = useState([])


    useEffect(() => {
        if (list !== undefined && moduleList !== list) {
            setModuleList(list)
        }

    }, [list])

    useEffect(()=>{
        setTableList(setTable())
    },[moduleList])

    function setTable() {
        var items = []
        moduleList.forEach((item, index) => {
            console.log(item)
            items.push(<ModuleBox key={item.moduleId} item={item} type={type} />)
        });
        // console.log(moduleList)
        return items
    }

    if (tableList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">名稱</th>
                                    <th className="text-center sorting col-sm-1">數量</th>
                                    <th className="text-center sorting col-sm-10">頁面</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

}

function ModuleBox({ item }) {
    const [module, setModule] = useState({})
    const [moduleName, setModuleName] = useState("")
    const [moduleId, setModuleId] = useState("")
    const [count, setCount] = useState("")
    const [items, setItems] = useState([])

    useEffect(() => {
        if (item !== undefined && item !== module) {
            setModule(item)
            setModuleName(item.moduleName)
            setModuleId(item.moduleId)
            setCount(item.count)
            setItems(item.items)
        }
    }, [item])

    function toEdit(){
        var tokenId = uuid(128, 64)
        setVal2Token('module', module, tokenId)
        window.location.replace("/ModuleEdit/"+tokenId);
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e=>toEdit()}>{moduleName}&nbsp;</a></td>
            <td className="text-center">{count}</td>
            <td className="">
                <div className="row">
                    <div className="col-sm-12" style={{overflowY: 'scroll', height:'150px'}}>
                {
                    items.map((item, index) =>
                        (
                            <div key={item.pageId+index} className="col-sm-12">
                                [{item.menuName}]                                
                                {item.pageName}
                                [{item.pageLink}]
                                <span className={"text-info"}>[{item.pageDescription}]</span>
                            </div>
                        )
                    )
                }
                </div>
            </div>
            </td>
        </tr>
    )
}
